import React from 'react';
import BuyersReview from '../../Shared/Buyers/BuyersReview';
import Company from '../../Shared/Company/Company';
import Contact from '../../Shared/Contact/Contact';
import NewCars from '../../Shared/NewCars/NewCars';
import Slider from '../../Shared/slider/Slider';
import Advertise from '../Advertise/Advertise';
import CategoryHome from '../CategoryHome/CategoryHome';

const Home = () => {
    return (
        <div>
           <Slider></Slider>
           <Advertise></Advertise>
           <CategoryHome></CategoryHome>
           <Company></Company>
           <NewCars></NewCars>
           {/* <BuyersReview></BuyersReview> */}
           <Contact></Contact>
        </div>
    );
};

export default Home;